var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.75 19.75H4.25c-.93 0-1.81-.36-2.47-1.03a3.48 3.48 0 0 1-1.03-2.47V3.75c0-.94.36-1.81 1.03-2.48C2.44.61 3.32.25 4.25.25h17.5c.93 0 1.81.36 2.47 1.02a3.53 3.53 0 0 1 1.03 2.48v12.5c0 .93-.36 1.81-1.03 2.47s-1.54 1.03-2.47 1.03m-19-12.5v9a1.5 1.5 0 0 0 1.5 1.5h17.5a1.5 1.5 0 0 0 1.5-1.5v-9zm0-2h20.5v-1.5a1.5 1.5 0 0 0-1.5-1.5H4.25a1.5 1.5 0 0 0-1.5 1.5zm10.25 7H6.75c-.55 0-1-.45-1-1s.45-1 1-1H13c.55 0 1 .45 1 1s-.45 1-1 1"
  })));
};
export default SvgCreditCard;